"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));
class TicketsApi extends _basic_data_hub_api.default {
  async getTicketsList() {
    let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      path: '/v2/tickets',
      queryParams: {
        ...query
      }
    });
  }
  async getTicketById(id) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      path: `/v2/ticket/${id}`,
      queryParams: {
        ...query
      }
    });
  }
  async getBoardsList() {
    let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      path: `/v2/ticket/boards`,
      queryParams: {
        ...query
      }
    });
  }
  async getTicketTypes() {
    let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      path: '/v2/ticket/types',
      queryParams: {
        ...query
      }
    });
  }
  async deleteTicketType() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      method: 'DELETE',
      path: `/v2/ticket/types`,
      payload: data
    });
  }
  async createTicketType() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      method: 'POST',
      path: '/v2/ticket/types',
      payload: data
    });
  }
  async updateTicketType(id) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'PUT',
      path: `/v2/ticket/types/${id}`,
      payload: data
    });
  }
  async getTicketRequesters() {
    let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      path: '/v2/ticket/requesters',
      queryParams: {
        ...query
      }
    });
  }
  async getFiltersByTicketType(type) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      path: `/v2/ticket/types/${type}/filters`,
      queryParams: {
        ...query
      }
    });
  }
  async getTicketLabels() {
    let query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      path: '/v2/ticket/labels',
      queryParams: {
        ...query
      }
    });
  }
  async createTicket() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      method: 'POST',
      path: '/v2/ticket',
      payload: data
    });
  }
  async updateTicket(id) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'PUT',
      path: `/v2/ticket/${id}`,
      payload: data
    });
  }
  async createBoard() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      method: 'POST',
      path: '/v2/ticket/board',
      payload: data
    });
  }
  async updateBoard(id) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'PUT',
      path: `/v2/ticket/board/${id}`,
      payload: data
    });
  }
  async addComment(id) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'POST',
      path: `/v2/ticket/${id}/comments`,
      payload: data
    });
  }
  async getComments(id) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'GET',
      path: `/v2/ticket/${id}/comments`,
      queryParams: {
        ...query
      }
    });
  }
  async getActivity(id) {
    let query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'GET',
      path: `/v2/ticket/${id}/activity`,
      queryParams: {
        ...query
      }
    });
  }
  async createLabel() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      method: 'POST',
      path: '/v2/ticket/label',
      payload: data
    });
  }
  async updateLabel(id) {
    let data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this._callApi({
      method: 'PUT',
      path: `/v2/ticket/label/${id}`,
      payload: data
    });
  }
  async deleteLabel() {
    let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return this._callApi({
      method: 'DELETE',
      path: `/v2/ticket/label`,
      payload: data
    });
  }
}
var _default = TicketsApi;
exports.default = _default;